package com.havn.app.core.localization

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.havn.app.ui.theme.LocalHavnThemeTokens

@Composable
fun HavnLanguageFlag(
    language: HavnLanguage,
    modifier: Modifier = Modifier
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = modifier.size(width = 38.dp, height = 26.dp),
        shape = MaterialTheme.shapes.extraSmall,
        color = theme.surface,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Canvas(Modifier.fillMaxSize()) {
            fun horizontal(colors: List<Color>) {
                val stripeHeight = size.height / colors.size
                colors.forEachIndexed { index, color ->
                    drawRect(
                        color = color,
                        topLeft = Offset(0f, stripeHeight * index),
                        size = Size(size.width, stripeHeight + 0.5f)
                    )
                }
            }

            fun vertical(colors: List<Color>) {
                val stripeWidth = size.width / colors.size
                colors.forEachIndexed { index, color ->
                    drawRect(
                        color = color,
                        topLeft = Offset(stripeWidth * index, 0f),
                        size = Size(stripeWidth + 0.5f, size.height)
                    )
                }
            }

            when (language) {
                HavnLanguage.English -> {
                    horizontal(
                        listOf(
                            Color(0xFFB22234),
                            Color.White,
                            Color(0xFFB22234),
                            Color.White,
                            Color(0xFFB22234),
                            Color.White,
                            Color(0xFFB22234)
                        )
                    )
                    drawRect(Color(0xFF3C3B6E), size = Size(size.width * 0.45f, size.height * 0.54f))
                }
                HavnLanguage.Slovak -> {
                    horizontal(listOf(Color.White, Color(0xFF0B4EA2), Color(0xFFEE1C25)))
                    drawCircle(Color(0xFFEE1C25), radius = size.height * 0.18f, center = Offset(size.width * 0.32f, size.height * 0.5f))
                }
                HavnLanguage.German -> horizontal(listOf(Color(0xFF111111), Color(0xFFDD0000), Color(0xFFFFCE00)))
                HavnLanguage.French -> vertical(listOf(Color(0xFF0055A4), Color.White, Color(0xFFEF4135)))
                HavnLanguage.Czech -> {
                    horizontal(listOf(Color.White, Color(0xFFD7141A)))
                    drawPath(
                        path = androidx.compose.ui.graphics.Path().apply {
                            moveTo(0f, 0f)
                            lineTo(size.width * 0.48f, size.height * 0.5f)
                            lineTo(0f, size.height)
                            close()
                        },
                        color = Color(0xFF11457E)
                    )
                }
                HavnLanguage.Spanish -> horizontal(listOf(Color(0xFFC60B1E), Color(0xFFFFC400), Color(0xFFFFC400), Color(0xFFC60B1E)))
                HavnLanguage.Italian -> vertical(listOf(Color(0xFF009246), Color.White, Color(0xFFCE2B37)))
                HavnLanguage.Croatian -> horizontal(listOf(Color(0xFFFF0000), Color.White, Color(0xFF171796)))
                HavnLanguage.Portuguese -> vertical(listOf(Color(0xFF006600), Color(0xFFFF0000)))
                HavnLanguage.Dutch -> horizontal(listOf(Color(0xFFAE1C28), Color.White, Color(0xFF21468B)))
                HavnLanguage.Polish -> horizontal(listOf(Color.White, Color(0xFFDC143C)))
                HavnLanguage.Hungarian -> horizontal(listOf(Color(0xFFCE2939), Color.White, Color(0xFF477050)))
                HavnLanguage.Romanian -> vertical(listOf(Color(0xFF002B7F), Color(0xFFFCD116), Color(0xFFCE1126)))
            }
        }
    }
}
